export default ($window, $translate) => {
    const filter = (label, isRequired) => {
        const optional = $translate.instant('question.(optional)');
        if (isRequired) {
            return `${label} <span class="required">*</span>`;
        }
        if (isRequired === false || isRequired === 0) {
            return `${label}<small> ${optional}</small>`;
        }
        return label;
    };

    filter.$stateful = true;

    return filter;
};



// WEBPACK FOOTER //
// ./src/app/filters/isRequired/index.js